'use client'

import DesktopNav from './desktop-nav'
import SidebarMenu from './sidebar-menu'
import LanguageSelector from './language-selector'
import AuthSection from './auth-section'
import { usePathname } from 'next/navigation'
import Logo from '~/components/sections/header/logo'
import React from 'react'

interface DesktopHeaderProps {
  isActive: boolean
  isSidebarOpen: boolean
  toggleSidebar: () => void
  isLangMenuOpen: boolean
  setIsLangMenuOpen: (isOpen: boolean) => void
  isScrolled: boolean
  langMenuRef: React.RefObject<HTMLDivElement>
}

export default function DesktopHeader({
  isActive,
  isSidebarOpen,
  toggleSidebar,
  isLangMenuOpen,
  setIsLangMenuOpen,
  isScrolled,
  langMenuRef,
}: DesktopHeaderProps) {
  const pathname = usePathname()
  return (
    <>
      <div className="hidden w-full items-center justify-between md:flex">
        <div className="flex items-center">
          <Logo isScrolled={isActive} />
        </div>
        <div className="grid items-center justify-items-center">
          <DesktopNav isScrolled={isActive} pathname={pathname} />
        </div>
        <div className="flex items-center gap-2">
          <LanguageSelector
            isActive={isActive}
            isLangMenuOpen={isLangMenuOpen}
            setIsLangMenuOpen={setIsLangMenuOpen}
            langMenuRef={langMenuRef}
          />
          <AuthSection isActive={isActive} />
        </div>

        {isSidebarOpen && <SidebarMenu isOpen={isSidebarOpen} onClose={toggleSidebar} />}
      </div>
    </>
  )
}
